import React from 'react';
import { Card } from 'antd';

const StyledCard = ({ children, style, ...props }) => (
  <Card
    bordered={false}
    style={{
      padding: 0,
      margin: 0,
      borderRadius: 0,
      boxShadow: 'none',
      border: '1px solid rgba(180,180,180,0.34)',
      //maxWidth: '537px',
      ...style,
    }}
    bodyStyle={{ padding: 0 }}
    {...props}
  >
    {children}
  </Card>
);

export default StyledCard;
